export class Controller {

    /** @ngInject */
    constructor($state, Alert,RemoteAppAccessService) {
        this.$state = $state;
        this.Alert = Alert;
        this.RemoteAppAccessService = RemoteAppAccessService;
        
    }

    $onInit() {
    	this.remoteAppsList=this.remoteApps;
        this.model = {application: this.application,applicationName: "", id:null};
        this.selectedGroups=[];
    }

    save() {
        this.isSaving = true;
        this.RemoteAppAccessService
            .save(this.companyId, this.appId, {sraRemoteApp: this.model, groups: this.selectedGroups})
            .then((newRemoteAppsList) => Object.assign(this.remoteApps, newRemoteAppsList))
            .then(() => this.$state.go('^'))
            .then(() => this.Alert('success', 'company.manage-application.remote-appaccess.add.added'))
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/add/add-remote-app.controller.js